import { V1Nurture } from "src/pages/reports/ffi/v1/types";

export const meta: Record<V1Nurture, Opportunity> = {
    spiritualGrowth: {
        title: "Spiritual Growth",
        prologue:
            "Administrators, teachers, and staff feel supported in their spiritual health and growth (2 Peter 3:18; Colossians 2:6-7; Psalm 92:12-14).",
    },
    mentoringLeaders: {
        title: "Mentoring Leaders",
        prologue:
            "Administrators have been mentored by other leaders and embody servant leadership by mentoring others (1 Corinthians 4:17; Philippians 2:22; 1 Timothy 1:2).",
    },
    supportiveCulture: {
        title: "Supportive Culture",
        prologue: "Alumni recall being supported by members of the school community (Galatians 6:2; Colossians 3:13).",
    },
    faithfulFriends: {
        title: "Faithful Friends",
        prologue:
            "Alumni report maintaining close friendships with friends from school, who continue to be strong in their faith (Proverbs 18:24).",
    },
    peerEncouragement: {
        title: "Peer Encouragement",
        prologue:
            "As “iron sharpens iron,” students feel supported by their peers in the Christian faith (Proverbs 27:17).",
    },
    parentalEncouragement: {
        title: "Parental Encouragement",
        prologue:
            "Parents and students spend quality time with each other and engage in conversation about the Christian faith (Deuteronomy 6:7; Psalm 78:4).",
    },
    parentPartnership: {
        title: "Parent Partnership",
        prologue:
            "Administrators understand the importance of a strong partnership between parents and the school for nurturing the child’s spiritual growth (Deuteronomy 6:7; Joshua 24:15; Psalms 78, 127).",
    },
    churchSchoolCongruence: {
        title: "Church School Congruence",
        prologue:
            "Students recognize how the teachings of their school and church agree with each other (Romans 12:4-5; Hebrews 10:25).",
    },
};
